import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import { Breadcrumb as BootsrapCrumb } from 'react-bootstrap';
import LocationInfo from '../location/Location';
import ChangeLocation from '../location/ChangeLocation';
import Modal from '../modal/Modal';
import { SitecoreLink } from '../link/Link';
import MediaQuery from "react-responsive";
import { locationDuck } from '../../ducks/location';
import { useFlags } from 'launchdarkly-react-client-sdk';
var locationOperations = locationDuck.operations;

var breadcrumb = function breadcrumb(props) {
  var _props$store = props.store,
      store = _props$store === void 0 ? {} : _props$store,
      _props$links = props.links,
      links = _props$links === void 0 ? [] : _props$links,
      _props$showBack = props.showBack,
      showBack = _props$showBack === void 0 ? false : _props$showBack,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
      _props$isError = props.isError,
      isError = _props$isError === void 0 ? false : _props$isError,
      _props$err = props.err,
      err = _props$err === void 0 ? {} : _props$err,
      _props$results = props.results,
      results = _props$results === void 0 ? [] : _props$results,
      _props$additionalResu = props.additionalResults,
      additionalResults = _props$additionalResu === void 0 ? [] : _props$additionalResu,
      _props$toggleChangeMo = props.toggleChangeModal,
      toggleChangeModal = _props$toggleChangeMo === void 0 ? function () {
    console.log('Set handler');
  } : _props$toggleChangeMo;
  var flags = useFlags();
  var useNewRebrandStyles = flags['releaseRebrandDstr6457'] || false;
  var finalLinks = links ? links.filter(function (item) {
    return item.title !== 'Home';
  }).slice(0, 3) : [];

  var isDetailPage = function isDetailPage() {
    var detailId = window.location.hash.substr(1);

    if (detailId == null || detailId.length === 0) {
      if (window.location.search.includes("productid")) {
        return true;
      }

      if (window.location.search.includes("sku")) {
        return true;
      }

      return false;
    } else {
      return true;
    }
  };

  var isProductDetailPage = isDetailPage();
  var lastItem = finalLinks.slice(-1)[0];

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      changeLocationModal = _useState2[0],
      setChangeLocationModal = _useState2[1]; // useEffect will reset


  useEffect(function () {
    setChangeLocationModal(!changeLocationModal);
  }, [props.changeLocationModal]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    size: "lg",
    className: "cb-modal--large",
    show: changeLocationModal,
    hide: toggleChangeModal
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ChangeLocation, {
    store: store,
    setStoreHandler: toggleChangeModal,
    changeLocationHandler: toggleChangeModal,
    showCurrent: false,
    results: results,
    additionalResults: additionalResults
  }))), /*#__PURE__*/React.createElement("div", {
    className: useNewRebrandStyles ? "" : "cb-l-border-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-breadcrumb ".concat(useNewRebrandStyles ? "" : "cb-bg-color-white")
  }, /*#__PURE__*/React.createElement(Container, {
    className: "h-100"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "h-100"
  }, /*#__PURE__*/React.createElement(Col, {
    className: "d-flex justify-content-start align-items-center"
  }, useNewRebrandStyles ? /*#__PURE__*/React.createElement(React.Fragment, null, showBack && /*#__PURE__*/React.createElement(BootsrapCrumb.Item, {
    as: "span",
    href: "/",
    className: "cb-breadcrumb__back"
  }), /*#__PURE__*/React.createElement(BootsrapCrumb, null, finalLinks.map(function (item, index) {
    return /*#__PURE__*/React.createElement(BootsrapCrumb.Item, {
      as: SitecoreLink,
      key: "breadcrumb-".concat(index),
      href: item === null || item === void 0 ? void 0 : item.url,
      active: false,
      field: {
        value: {
          text: item === null || item === void 0 ? void 0 : item.text,
          title: item === null || item === void 0 ? void 0 : item.text,
          href: item === null || item === void 0 ? void 0 : item.url
        }
      }
    }, item === null || item === void 0 ? void 0 : item.title);
  }))) : /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, showBack && /*#__PURE__*/React.createElement(BootsrapCrumb.Item, {
    as: "span",
    href: "/",
    className: "cb-breadcrumb__back"
  }), /*#__PURE__*/React.createElement(BootsrapCrumb, null, finalLinks.map(function (item, index) {
    return /*#__PURE__*/React.createElement(BootsrapCrumb.Item, {
      as: SitecoreLink,
      key: "breadcrumb-".concat(index),
      href: item === null || item === void 0 ? void 0 : item.url,
      active: false,
      field: {
        value: {
          text: item === null || item === void 0 ? void 0 : item.text,
          title: item === null || item === void 0 ? void 0 : item.text,
          href: item === null || item === void 0 ? void 0 : item.url
        }
      }
    }, item === null || item === void 0 ? void 0 : item.title);
  }))), !useNewRebrandStyles && /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 990
  }, isProductDetailPage ? /*#__PURE__*/React.createElement("span", {
    className: "cb-breadcrumb__back"
  }, /*#__PURE__*/React.createElement("a", {
    href: lastItem === null || lastItem === void 0 ? void 0 : lastItem.url
  })) : /*#__PURE__*/React.createElement("div", null), showBack && !isProductDetailPage && /*#__PURE__*/React.createElement(BootsrapCrumb.Item, {
    as: "span",
    href: "/",
    className: "cb-breadcrumb__back"
  }), /*#__PURE__*/React.createElement(BootsrapCrumb, null, (isProductDetailPage ? [lastItem] : finalLinks).map(function (item, index) {
    return /*#__PURE__*/React.createElement(BootsrapCrumb.Item, {
      as: SitecoreLink,
      key: "breadcrumb-".concat(index),
      href: item === null || item === void 0 ? void 0 : item.url,
      active: false,
      field: {
        value: {
          text: item === null || item === void 0 ? void 0 : item.text,
          title: item === null || item === void 0 ? void 0 : item.text,
          href: item === null || item === void 0 ? void 0 : item.url
        }
      }
    }, item === null || item === void 0 ? void 0 : item.title);
  })))), /*#__PURE__*/React.createElement(Col, {
    className: "d-flex justify-content-end align-items-center"
  }, /*#__PURE__*/React.createElement(LocationInfo, {
    store: store,
    simple: true,
    isLoading: isLoading,
    isError: isError,
    err: err,
    changeLocationHandler: toggleChangeModal
  })))))));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    results: state.location.results,
    additionalResults: state.location.additionalResults,
    changeLocationModal: state.location.changeLocationModal
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    toggleChangeModal: function toggleChangeModal() {
      return dispatch(locationOperations.toggleChangeModal());
    }
  };
};

var Breadcrumb = connect(mapStateToProps, mapDispatchToProps)(breadcrumb);
export { Breadcrumb };